import { render, staticRenderFns } from "./RoomCardServices.vue?vue&type=template&id=0046a2ff&scoped=true"
import script from "./RoomCardServices.vue?vue&type=script&lang=js"
export * from "./RoomCardServices.vue?vue&type=script&lang=js"
import style0 from "./RoomCardServices.vue?vue&type=style&index=0&id=0046a2ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046a2ff",
  null
  
)

export default component.exports